import React from 'react';
import { FadeIn, Section } from './Section';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'En tres semanas organicé mi oferta, puse mis precios y conseguí mis primeras clientas. Llevaba dos años con la habilidad y sin cobrar por ella. Este ebook cambió todo.',
  name: 'Camila R.',
  location: 'Buenos Aires',
  role: 'Diseñadora freelance'
}, {
  quote: 'Siempre supe que podía cobrar más pero me bloqueaba el miedo a que me dijeran que era caro. Con Mujer Expansiva entendí de dónde venía ese miedo y cómo soltarlo. En un mes dupliqué lo que cobraba.',
  name: 'Valentina S.',
  location: 'Córdoba',
  role: 'Coach de bienestar'
}, {
  quote: 'No tenía seguidores, no tenía experiencia vendiendo online. Tenía una habilidad y muchas ganas. En cuatro semanas generé mis primeros ingresos propios. Por primera vez en años me sentí libre.',
  name: 'Lucía M.',
  location: 'Rosario',
  role: 'Profesora de inglés online'
}, {
  quote: 'Llevaba años pensando que "todavía no estaba lista". Mujer Expansiva me sacó de esa trampa. En 40 días lancé mi primer servicio digital y facturé más que en mi sueldo entero.',
  name: 'Florencia M.',
  location: 'Mendoza',
  role: 'Asesora de imagen'
}, {
  quote: 'Lo que más me cambió no fue solo el método — fue la mentalidad. Por primera vez no me sentí culpable de cobrar bien. Hoy tengo tres clientas fijas y la agenda se me llena sola.',
  name: 'Antonella T.',
  location: 'Montevideo',
  role: 'Fotógrafa de bodas'
}, {
  quote: 'Soy madre y trabajaba 9 horas para apenas llegar. Empecé a aplicar lo de la Parte II en mis ratos libres y ya estoy lista para renunciar. Es la libertad que nunca creí posible.',
  name: 'Mariana P.',
  location: 'Santiago de Chile',
  role: 'Profesora particular'
}];
export function Testimonials() {
  return <Section bg="plum" className="border-y border-plum-light overflow-hidden" data-id="element-305">
      <FadeIn className="text-center mb-8 md:mb-16" data-id="element-306">
        <h2 className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-gold mb-3 md:mb-4" data-id="element-307">
          Lo que dicen las mujeres expansivas
        </h2>
        <p className="font-serif text-2xl md:text-4xl text-cream italic max-w-2xl mx-auto leading-tight" data-id="element-308">
          Historias reales de mujeres que{' '}
          <span className="text-gold not-italic font-medium" data-id="element-309">
            dejaron de esperar
          </span>
          .
        </p>
      </FadeIn>

      {/* Mobile: horizontal scroll | Desktop: 3-col grid, 2 rows */}
      <div className="flex md:grid md:grid-cols-3 gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-4 md:pb-0 -mx-5 px-5 md:mx-0 md:px-0" data-id="element-310">
        {testimonials.map((t, i) => <FadeIn key={i} delay={i % 3 * 0.1} className="flex flex-col h-full min-w-[85%] md:min-w-0 snap-center bg-plum-light/15 md:bg-plum-light/10 p-6 md:p-7 rounded-sm border border-gold/10 hover:border-gold/30 transition-colors duration-300" data-id="element-311">
            {/* 5-star rating */}
            <div className="flex gap-0.5 mb-3 md:mb-4" data-id="element-312">
              {[...Array(5)].map((_, idx) => <StarIcon key={idx} size={12} className="text-gold" fill="currentColor" data-id="element-313" />)}
            </div>

            <QuoteIcon className="text-gold mb-3 md:mb-4 opacity-40" size={20} data-id="element-314" />
            <p className="font-serif text-base md:text-lg leading-relaxed mb-5 md:mb-6 flex-grow text-cream/95 italic" data-id="element-315">
              "{t.quote}"
            </p>
            <div className="pt-4 md:pt-5 border-t border-gold/15" data-id="element-316">
              <p className="font-bold text-gold uppercase tracking-widest text-xs mb-1" data-id="element-317">
                {t.name}
              </p>
              <p className="text-cream/55 text-xs" data-id="element-318">
                {t.location} · {t.role}
              </p>
            </div>
          </FadeIn>)}
      </div>

      {/* Mobile dot indicators */}
      <div className="flex justify-center gap-1.5 mt-4 md:hidden" data-id="element-319">
        {testimonials.map((_, i) => <div key={i} className="w-1 h-1 rounded-full bg-gold/40" data-id="element-320" />)}
      </div>
    </Section>;
}